module.exports = __webpack_public_path__ + "static/media/03-conduct-walkthrough.e87fd715.svg";